<!-- <section class="modal-edit-content "> -->
<!-- <div class="overlay"></div> -->

<!-- <div class="modal animate__animated animate__slideInRight" > -->

<efx-modal 
 [preventDefaultClose]="true"
[title]="tituloModal" 
[(show)]="showModal" 
[showFooter]="false" 
[size]="modalSize.extraLarge">
  <section class="mb-5 h-100 row">

    @for (campoInput of camposModal?.inputs; track campoInput) {
      <div class="col-lg-4">
        @if (showInputDependCheckbox(campoInput)) {
          <div class="p-0 m-0">
            <label class="efx-label" [for]="campoInput.nameService">
              {{campoInput.label | titlecase}}
            </label>
            @if (campoInput.typeInput !== 'select') {
              <input class="efx-input" [type]="campoInput.typeInput"
                [id]="campoInput.nameService" [name]="campoInput.nameService" [(ngModel)]="campoInput.value" />
            }
            @if (campoInput.typeInput === 'select') {
              <select class="efx-select w-100" [id]="campoInput.nameService"
                [name]="campoInput.nameService" [(ngModel)]="campoInput.value">
                @for (valuesOption of campoInput.values; track valuesOption) {
                  <option [value]="valuesOption.value">
                    {{valuesOption.label | titlecase}}
                  </option>
                }
              </select>
            }
          </div>
        }
      </div>
    }
    <div class="row">
      @for (campoCheckbox of camposModal?.checkboxs; track campoCheckbox) {
        <div class="col-lg-4">
          <input class="efx-checkbox" type="checkbox" [id]="campoCheckbox.nameService"
            [(ngModel)]="campoCheckbox.value" />
          <label [for]="campoCheckbox.nameService">
            {{campoCheckbox.label | titlecase}}
          </label>
        </div>
      }
    </div>


  </section>
  <div class="d-flex justify-content-end gap-3">
    <button class="efx-button-secondary" (click)="onBtnCancelar.emit()">Cancelar</button>
    <button class="efx-button-primary" (click)="onBtnGuardar.emit(getReturnEditData())">
      <span class="material-symbols-outlined"> save </span>
      Guardar
    </button>
  </div>

</efx-modal>
<!-- </div>
</section> -->